import React, {useState} from 'react'
import styles from './styles/operations_header.module.css';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faArrowLeft, faTrash, faCalendarAlt} from "@fortawesome/free-solid-svg-icons";
import {Link} from "react-router-dom";
import Modal from "./modal/modal";
import axiosInstance from "../AxiosInstance";
import Scheduler from "../screens/operations/components/scheduler/Scheduler";
import {useTranslation} from "react-i18next";

export default function OperationsHeader() {
    const {t} = useTranslation();
    const [showModal, setShowModal] = useState(false);
    const [showScheduler, setShowScheduler] = useState(false);
    const operation_group_id = parseInt(localStorage.getItem('operation_group_id'));
    const project = JSON.parse(localStorage.getItem('project'));
    const deleteGroup = () => {
        axiosInstance.delete(`operation_group_delete/${operation_group_id}/`).then((res) => {
            localStorage.removeItem('operation_group_id');
            window.location.replace('/operations/')
        })
        setShowModal(false)
    }

    return (
        <div className={`${styles.header_container} py-3`}>
            <Modal name={t('operations.header.deleteGroupConfirm')} description={t('operations.header.deleteGroupDesc')} show={showModal} setter={setShowModal} buttonName={t('operations.header.deleteGroup')} onClick={deleteGroup}/>
            <Scheduler show={showScheduler} onClose={() => setShowScheduler(false)} projectId={project?.id} operationGroupId={operation_group_id} />
            <div className="d-flex flex-row justify-content-between">
                <Link className={`${styles.exit_button}`} to={'/operations/'}>
                    <FontAwesomeIcon icon={faArrowLeft} className="pt-1 pe-2"/>
                    <div className={`fw-bold ${styles.buttonText}`}>{t('operations.header.exit')}</div>
                </Link>
                <div className="d-flex flex-row align-items-center" style={{gap: '16px'}}>
                    <div className={`${styles.scheduleButton}`} onClick={() => setShowScheduler(true)}>
                        <FontAwesomeIcon icon={faCalendarAlt} className={'pe-2'}/>
                        <div className={styles.buttonText}>{t('operations.header.schedules')}</div>
                    </div>
                </div>
                <div className={`${styles.deleteButton}`} onClick={() => setShowModal(true)}>
                    <FontAwesomeIcon icon={faTrash} color={'#E11D48'} className={'pe-2'}/>
                    <div style={{color: '#E11D48'}} className={styles.buttonText}>{t('operations.header.deleteGroup')}</div>
                </div>
            </div>
        </div>
    )
}
